import {
  FilePurpose,
  isAllowedImageType,
  isAllowedUploadType,
  useUploadMedia,
} from '@platform/media';
import { mediaApi } from '@/shared/api/media.api';

/**
 * 게시판 본문 이미지 업로드 훅.
 * 에디터에 이미지를 넣는 즉시 S3로 올리고 CDN URL을 받는다(본문 jsonb엔 URL만 저장).
 *
 * 즉시 confirm 까지 수행해 MediaResponse(url 포함)를 바로 받는다.
 * (본문 이미지는 글 저장과 무관하게 바로 보여줘야 하므로)
 */
export function useBoardImageUpload() {
  return useUploadMedia({
    getPresignedUrl: mediaApi.getPresignedUrl,
    confirmUpload: mediaApi.confirmUpload,
    defaultPurpose: FilePurpose.POST,
    validateType: isAllowedImageType,
  });
}

/**
 * 게시판 첨부 문서 업로드 훅.
 * 이미지/문서 모두 허용. confirm 까지 수행해 url/메타를 받아 첨부 목록에 추가.
 */
export function useBoardAttachmentUpload() {
  return useUploadMedia({
    getPresignedUrl: mediaApi.getPresignedUrl,
    confirmUpload: mediaApi.confirmUpload,
    defaultPurpose: FilePurpose.DOCUMENT,
    validateType: isAllowedUploadType,
  });
}
